jQuery(function(){
  if(!jQuery('body').hasClass('single-product')) {
    return
  }

  /*************
  Variables
  */

  /*************
  Function Calls
  */
  jQuery(window).on('load', function() {
    giftCardFix()

    // adjustProductSliderThumbnailHeight
  })

  function giftCardFix() {
    const giftCardInput = jQuery('input#mwb_wgm_send_giftcard_ship.mwb_wgm_send_giftcard, input#mwb_wgm_send_giftcard_download.mwb_wgm_send_giftcard')

    if(giftCardInput) {
      giftCardInput.trigger('click')
    }
  }
})
